import React, { memo, useMemo } from 'react'
import { Grid, Card, CardHeader, Avatar, Box } from '@mui/material'
import { AlertProps } from './Alert.types'
import { getColor } from './Colors.types'
import { SuccessIcon, ErrorIcon, InfoIcon, WarningIcon } from './Icons'

function Alert({
    variant,
    title,
    subheader,
    button,
    plain,
    margin = 2,
    elevation = 2,
}: AlertProps) {
    const color = useMemo(() => getColor(variant), [variant])
    const icon = useMemo(() => {
        switch (variant) {
            case 'info':
                return <InfoIcon />
            case 'success':
                return <SuccessIcon />
            case 'warning':
                return <WarningIcon />
            case 'error':
                return <ErrorIcon />
        }
    }, [variant])

    return (
        <Grid item xs={12}>
            <Box mb={margin}>
                <Card
                    variant={plain ? 'outlined' : 'elevation'}
                    elevation={elevation}
                    sx={
                        plain
                            ? {
                                  borderColor: color,
                              }
                            : undefined
                    }
                >
                    <CardHeader
                        avatar={
                            <Avatar
                                style={{
                                    backgroundColor: color,
                                }}
                            >
                                {icon}
                            </Avatar>
                        }
                        title={title}
                        subheader={subheader}
                        action={button}
                    />
                </Card>
            </Box>
        </Grid>
    )
}

export default memo(Alert)
